---
title: ❄️ Winter Field Day 2026 — DSARC Club Activation (K7DSC)
date: 2026-01-24
endDate: 2026-01-25
location: Latah County Emergency Management Building, 2370 N Polk Extension, Moscow, ID
description: Operate Winter Field Day with DSARC (K7DSC) from the Latah County Emergency Management Building for the full event window. Warm shelter, food, and plenty of radios—come operate, learn, and experiment. ❄️📡
published: true
---

# ❄️ Winter Field Day 2026 — DSARC Club Activation (K7DSC)

Join the Do Something Amateur Radio Club for Winter Field Day. We’ll run **K7DSC** as **2I (Indoor)** from the Latah County Emergency Management Building on Polk Extension for the full event window. Warm space, food, and lots of gear—come operate, learn, or just hang out.

---

## ⏱ Club Schedule & Operating Plan
- We will operate from Polk Extension for the **full official WFD window** (staffing permitting).
- **Club callsign & class:** K7DSC — 2I (Indoor)

### 🔧 Setup
- **Friday — January 23 @ 6:00 PM PST**
  - Initial setup (computers, logging, networking)
  - Staying within the 12-hour cumulative setup limit

### 📻 Operating Period (per WFD Rules)
- **Start:** Saturday, January 24 @ 8:00 AM PST (1600 UTC)
- **End:** Sunday, January 25 @ 1:59 PM PST (2159 UTC)
- We’ll operate from this location for the duration of the official operational period.

---

## 📍 Location
**Latah County Emergency Management Building**  
2370 N Polk Extension, Moscow, ID 83843  
<a href="https://maps.app.goo.gl/uqBRfTBmekTuyZqeA" target="_blank" rel="noopener noreferrer">Open in Google Maps</a>

---

<div class="mb-8">
  <iframe title="Map of Winter Field Day location - 2370 N Polk Ext, Moscow, ID" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2733.397193161824!2d-116.9972685225216!3d46.75706684625334!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x549f89eb009fd62f%3A0x8b1579fd92ae333c!2s2370%20N%20Polk%20Ext%2C%20Moscow%2C%20ID%2083843!5e0!3m2!1sen!2sus!4v1735864037788!5m2!1sen!2sus" width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
</div>

---

## 🎒 What to Bring
- Warm layers and indoor shoes
- Snacks and drinks you like between meals
- Headset or hand mic (helps in a shared room)
- Laptop/tablet for logging or digital modes (optional)
- Power strip/extension and USB cables if you bring gear
- Flashlight or headlamp for setup/teardown

---

## 🎁 What We’ll Provide
- Heated indoor space with tables and power
- Club radios, antennas, and networking/logging setup
- Lunch and dinner on Saturday
- Plenty of accessories (coax, adapters, power distribution)

---

## 🍽 Food & Comfort
- Lunch and dinner provided on Saturday
- Please bring snacks, drinks, and any personal comfort items for a long operating day

---

## 📡 Equipment & Operating
- Club radios and antennas available—bring your own if you’d like
- Great time to test portable/experimental setups, try new antennas or modes, and work digital/voice/CW

---

## 🛰️ Club Station Details
- Callsign: **K7DSC**
- Category: **2I (Indoor)**
- ARRL Section: **ID**

---

## 🛠 Projects & Collaboration
Have a project or experiment? Bring it—radios, antennas, electronics builds, networking/digital ideas, or emergency-comms projects. This is a relaxed, hands-on weekend to share knowledge and help each other.

---

## 👥 Everyone Is Welcome
You do not need to be licensed to attend.
- Licensed operators can get on the air and mentor
- Unlicensed participants can sit with operators, learn how stations work, and get on the air under supervision
- Amateur radio testing will be available throughout Saturday

---

## ℹ️ Learn More
- Official site: <https://winterfieldday.org/>
- Full rules (PDF): <https://winterfieldday.org/downloads/2026-rules-v3.pdf>
- Rules overview: <https://winterfieldday.org/sop.php>
- FAQ & resources: <https://winterfieldday.org/resources.php>
- Questions? Reach out on Discord or at <https://dsarc.us/contact>.
